import { Preferences } from "@capacitor/preferences";
import { QueryClient } from "@tanstack/react-query";
import { acceptInvitation } from "@/api/organisations";

export async function handlePendingInvitation(
  queryClient: QueryClient
): Promise<void> {
  const { value: pendingId } = await Preferences.get({
    key: "pending_invitation_id",
  });
  if (!pendingId) return;

  await Preferences.remove({ key: "pending_invitation_id" });
  try {
    await acceptInvitation(pendingId);
    await queryClient.invalidateQueries({ queryKey: ["organisations"] });
    await queryClient.invalidateQueries({
      queryKey: ["visible-organisations"],
    });
  } catch {
    // Invitation may be expired or already accepted — silently fail
  }
}
